import {ChangeDetectionStrategy, InputSignal} from '@angular/core';
import {Component, input} from '@angular/core';
import {DatePipe} from "@angular/common";
import {TranslatePipe} from "../../pipes/translate.pipe";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-divider-date',
    imports: [
        DatePipe,
        TranslatePipe
    ],
    templateUrl: './divider-date.component.html',
    styleUrl: './divider-date.component.scss'
})
export class DividerDateComponent {
  public date: InputSignal<Date> = input<Date>(new Date());

  public today: Date = new Date();
  public yesterday: Date = new Date(new Date().setDate(new Date().getDate() - 1));
}
